import React from "react";
import { Link } from "react-router-dom";
import { Calendar, MessageCircle } from "lucide-react";
import { whatsappLink } from "../../lib/whatsapp";

export const ProjectCta = ({ isDE }) => (
  <section className="px-6 md:px-12 lg:px-24 mb-12">
    <div className="max-w-5xl mx-auto glass-strong rounded-3xl p-8 md:p-12 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-brand-orange/15 blur-3xl pointer-events-none" />
      <div className="relative grid lg:grid-cols-[1.3fr_1fr] gap-8 items-center">
        <div>
          <h2 className="font-display font-bold text-2xl md:text-4xl text-white tracking-tight leading-tight">
            {isDE ? "Klingt nach etwas, das du brauchst?" : "Sounds like something you need?"}
          </h2>
          <p className="mt-4 text-white/65 leading-relaxed max-w-xl">
            {isDE
              ? "30-minütiges Strategiegespräch, kostenlos und unverbindlich. Wir hören zu und geben konkrete nächste Schritte."
              : "30-minute strategy call, free and non-binding. We listen and give concrete next steps."}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <Link to="/book" className="btn-primary !justify-center" data-testid="project-cta-calendly">
            <Calendar className="w-4 h-4" /> {isDE ? "Strategiegespräch buchen" : "Book a strategy call"}
          </Link>
          <a
            href={whatsappLink(isDE ? "Hallo, ich habe eine Frage zu eurem Showcase." : "Hi, I have a question about your showcase.")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary !justify-center !border-[#25D366]/40"
            data-testid="project-cta-whatsapp"
          >
            <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp
          </a>
          <Link to="/contact" className="btn-ghost !justify-center" data-testid="project-cta-contact">
            {isDE ? "Kontaktformular" : "Contact form"}
          </Link>
        </div>
      </div>
    </div>
  </section>
);
